function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useState } from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Select, SelectItem, Textarea } from '@heroui/react';
import { Flag } from 'lucide-react';
export var ReportReason = /*#__PURE__*/ function(ReportReason) {
    ReportReason["SPAM"] = "SPAM";
    ReportReason["INAPPROPRIATE_CONTENT"] = "INAPPROPRIATE_CONTENT";
    ReportReason["HARASSMENT"] = "HARASSMENT";
    ReportReason["COPYRIGHT_VIOLATION"] = "COPYRIGHT_VIOLATION";
    ReportReason["FALSE_INFORMATION"] = "FALSE_INFORMATION";
    ReportReason["OTHER"] = "OTHER";
    return ReportReason;
}({});
var _obj;
var REPORT_REASON_LABELS = (_obj = {}, _define_property(_obj, "SPAM", '스팸/광고'), _define_property(_obj, "INAPPROPRIATE_CONTENT", '부적절한 콘텐츠'), _define_property(_obj, "HARASSMENT", '괴롭힘/혐오 발언'), _define_property(_obj, "COPYRIGHT_VIOLATION", '저작권 침해'), _define_property(_obj, "FALSE_INFORMATION", '허위 정보'), _define_property(_obj, "OTHER", '기타'), _obj);
export var ReportDialog = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, targetType = param.targetType, targetId = param.targetId, targetTitle = param.targetTitle, onSubmit = param.onSubmit, _param_size = param.size, size = _param_size === void 0 ? 'lg' : _param_size;
    var _useState = _sliced_to_array(useState(''), 2), reason = _useState[0], setReason = _useState[1];
    var _useState1 = _sliced_to_array(useState(''), 2), description = _useState1[0], setDescription = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isSubmitting = _useState2[0], setIsSubmitting = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), error = _useState3[0], setError = _useState3[1];
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!reason) {
                            setError('신고 사유를 선택해주세요.');
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            onSubmit({
                                reason: reason,
                                description: description.trim() || undefined
                            })
                        ];
                    case 2:
                        _state.sent();
                        // Reset form
                        setReason('');
                        setDescription('');
                        onClose();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        setError(_instanceof(err, Error) ? err.message : '신고 접수 중 오류가 발생했습니다.');
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsSubmitting(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = function() {
        if (!isSubmitting) {
            setReason('');
            setDescription('');
            setError(null);
            onClose();
        }
    };
    var targetTypeLabel = targetType === 'course' ? '강의' : '로드맵';
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isOpen,
        onClose: handleClose,
        size: size
    }, /*#__PURE__*/ React.createElement(ModalContent, {
        onClick: function(e) {
            return e.stopPropagation();
        }
    }, /*#__PURE__*/ React.createElement(ModalHeader, {
        className: "flex items-center gap-2"
    }, /*#__PURE__*/ React.createElement(Flag, {
        className: "w-5 h-5 text-warning"
    }), /*#__PURE__*/ React.createElement("span", null, targetTypeLabel, " 신고")), /*#__PURE__*/ React.createElement(ModalBody, null, /*#__PURE__*/ React.createElement("div", {
        className: "space-y-4"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", {
        className: "text-sm text-default-600 mb-2"
    }, "신고 대상: ", /*#__PURE__*/ React.createElement("strong", null, targetTitle)), /*#__PURE__*/ React.createElement("p", {
        className: "text-xs text-default-500"
    }, "허위 신고 시 제재를 받을 수 있습니다. 신중하게 신고해주세요.")), /*#__PURE__*/ React.createElement(Select, {
        label: "신고 사유",
        placeholder: "신고 사유를 선택하세요",
        selectedKeys: reason ? [
            reason
        ] : [],
        onSelectionChange: function(keys) {
            var selectedReason = Array.from(keys)[0];
            setReason(selectedReason || '');
            setError(null);
        },
        isRequired: true,
        isDisabled: isSubmitting,
        errorMessage: error && !reason ? error : undefined
    }, Object.entries(REPORT_REASON_LABELS).map(function(param) {
        var _param = _sliced_to_array(param, 2), value = _param[0], label = _param[1];
        return /*#__PURE__*/ React.createElement(SelectItem, {
            key: value,
            value: value
        }, label);
    })), /*#__PURE__*/ React.createElement(Textarea, {
        label: "상세 설명 (선택사항)",
        placeholder: "신고 내용을 자세히 설명해주세요...",
        value: description,
        onValueChange: setDescription,
        minRows: 3,
        maxRows: 6,
        isDisabled: isSubmitting,
        description: "신고 내용에 대한 자세한 정보를 제공하면 더 빠르게 검토할 수 있습니다."
    }), error && reason && /*#__PURE__*/ React.createElement("p", {
        className: "text-danger text-sm"
    }, error))), /*#__PURE__*/ React.createElement(ModalFooter, null, /*#__PURE__*/ React.createElement(Button, {
        color: "default",
        variant: "light",
        onPress: handleClose,
        isDisabled: isSubmitting
    }, "취소"), /*#__PURE__*/ React.createElement(Button, {
        color: "danger",
        onPress: handleSubmit,
        isLoading: isSubmitting,
        isDisabled: !reason
    }, "신고하기"))));
};
